import * as React from 'react';
import { DiseaseGridModel, DiseaseForGridModel, DiseaseFilterSettingsModel } from "../../models";

const diseasesList = (props) => {

    const listItems =
        props.diseases.map((m: DiseaseForGridModel) =>
            <li key={m.diseaseId + 'disease'}>
                <div className="item-info">
                    <div className="item-name">
                        {m.diseaseCode} {m.diseaseName}
                    </div>

                </div>
            </li>);

    return (
        <ul className="list-items">
            {listItems}
        </ul>
    )
}

export default diseasesList;
